import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import type { DeliveryFilter } from "../lib/delivery";

import { notifKeys } from "./query-keys";

export function useDeliveries(filter: DeliveryFilter = {}) {
  return useQuery({
    queryKey: notifKeys.deliveries(filter),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/notifications/deliveries", {
        params: { query: filter },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
